// Yayıncı öz-servis katmanı (Faz 5) — customer'ın api/client.js'inden bağımsız,
// ayrı token deposu ve ayrı endpoint namespace'i (/api/publisher/*).

const API_URL = process.env.API_URL != null ? process.env.API_URL : 'http://localhost:3001';
const TOKEN_KEY = 'vokelle_pub_token';

export function getPublisherToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setPublisherToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}
export function clearPublisherToken() {
  localStorage.removeItem(TOKEN_KEY);
}

async function pubRequest(method, path, body, { auth = true } = {}) {
  const token = auth ? getPublisherToken() : null;
  const res = await fetch(API_URL + '/api/publisher' + path, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body != null ? JSON.stringify(body) : undefined,
  });
  let json = null;
  try { json = await res.json(); } catch (_) {}
  if (!res.ok) {
    const err = new Error(json?.error?.message || 'request_failed');
    err.code = json?.error?.code || 'request_failed';
    err.status = res.status;
    throw err;
  }
  return json;
}

export const pubApi = {
  register: (data) => pubRequest('POST', '/register', data, { auth: false }),
  login: (data) => pubRequest('POST', '/login', data, { auth: false }),
  me: () => pubRequest('GET', '/me'),
  createLink: (data) => pubRequest('POST', '/links', data),
  updateLink: (id, data) => pubRequest('PATCH', `/links/${id}`, data),
  listLinks: () => pubRequest('GET', '/links'),
  linkStats: (id) => pubRequest('GET', `/links/${id}/stats`),
  referrals: () => pubRequest('GET', '/referrals'),
  acceptTerms: () => pubRequest('POST', '/accept-terms'),
  async uploadAvatar(file) {
    const fd = new FormData();
    fd.append('avatar', file);
    const res = await fetch(API_URL + '/api/publisher/avatar', {
      method: 'POST',
      headers: { Authorization: `Bearer ${getPublisherToken()}` },
      body: fd,
    });
    const json = await res.json().catch(() => null);
    if (!res.ok) {
      const err = new Error(json?.error?.message || 'request_failed');
      err.code = json?.error?.code || 'request_failed';
      err.status = res.status;
      throw err;
    }
    return json;
  },
};

export { API_URL };
